var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBmReports = function SvgBmReports(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 19.286",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.643,16.286h5.786a.643.643,0,0,0,0-1.286H6.643a.643.643,0,0,0,0,1.286Z",
    transform: "translate(-2.143 -5.357)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.643,12.286H9.214a.643.643,0,1,0,0-1.286H6.643a.643.643,0,1,0,0,1.286Z",
    transform: "translate(-2.143 -3.929)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.643,20.286h5.786a.643.643,0,1,0,0-1.286H6.643a.643.643,0,1,0,0,1.286Z",
    transform: "translate(-2.143 -6.786)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.643,24.286h5.786a.643.643,0,1,0,0-1.286H6.643a.643.643,0,1,0,0,1.286Z",
    transform: "translate(-2.143 -8.214)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.48,29.989h.026l-.013-.019Z",
    transform: "translate(-4.1 -10.704)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.143,5H.643A.643.643,0,0,0,0,5.643V20.429a.643.643,0,0,0,.643.643H10.929V19.786H1.286V6.286H13.5v13.5H9.643v1.286h4.5a.643.643,0,0,0,.643-.643V5.643A.643.643,0,0,0,14.143,5Z",
    transform: "translate(0 -1.786)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.48,24.989h.026l-.013-.019Z",
    transform: "translate(-5.886 -8.918)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.286,1.929V1.286H18.5v13.5h-.643v1.286h1.286a.643.643,0,0,0,.643-.643V.643A.643.643,0,0,0,19.143,0H5.643A.643.643,0,0,0,5,.643V1.929Z",
    transform: "translate(-1.786)"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBmReports, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/BM_Reports.df29a369.svg";
export { ForwardRef as ReactComponent };